import { StyleSheet } from 'aphrodite';
import { AppTheme, AppStyles } from '../styles/AppTheme';

// Styles to be reused between more than one component
export const CommonStyles = StyleSheet.create({
  textfulPageContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    margin: 20,
    maxWidth: AppTheme.viewPort,
    paddingBottom: 100
  },
  textfulPageSubtitle: {
    fontSize: 16
  },
  textfulPagePara: {
    fontSize: 12
  },
  logoImage: {
    height: 40
  },
  linkTextColor: {
    color: 'black'
  },
  innerContainer: {
    flex: 1,
    marginTop: 10,
  },
  outerContainer: {
    width: '100%'
  },
  questionMainTitleContainer: {
    display: 'flex',
    //alignItems: 'center'
  },
  questionMainTitle: {
    fontSize: AppTheme.subTitleSize,
    color: AppTheme.primaryColor,
    margin: AppTheme.pMargin,
    fontWeight: 'bold',
    flex: 1,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767,
    }
  },
  questionDetailContainer: {
    width: 25,
    height: 25,
    border: '2px solid' + AppTheme.tertiaryColor,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 20,
    cursor: 'pointer'
  },
  questionDetailContent: {
    margin: 0,
    color: AppTheme.tertiaryColor,
    fontSize: 25,
  },
  questionSubTitle: {
    fontSize: AppTheme.subTitleSize,
    color: AppTheme.textColorVariant,
    margin: AppTheme.pMargin,
    marginTop: 5,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767,
    }
  },
  innerSelection: {
    // marginLeft: 50
    alignItems: 'flex-start'
  },
  controlLabel: {
    ':hover': {
      backgroundColor: 'unset'
    }
  },
  formLabel: {
    marginLeft: 5,
    fontSize: AppTheme.subTitleSize,
    color: AppTheme.primaryColor,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767,
    }
  },
  link: {
    textDecoration: 'none'
  },
  colouredLink: {
    color: AppTheme.tertiaryColor,
    textDecoration: 'none',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 0,
    cursor: 'default'
  },
  headerContent: {
    fontSize: 60,
    color: AppTheme.primaryColor,
    margin: AppTheme.pMargin,
    textAlign: 'center',
    '@media (max-width: 767px)': {
      fontSize: 30,
    }
  },
  textField: {
    // maxWidth: 320,
    maxHeight: 60,
    background: AppTheme.secondaryBg + '0% 0% no-repeat padding-box',
    border: '3px solid' + AppTheme.borderColor,
    zIndex: 0,
    borderRadius: 18,
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
  },
  textFieldDisabled: {
    // maxWidth: 320,
    maxHeight: 60,
    background:  'lightgrey' + '0% 0% no-repeat padding-box',
    backgroundColor:  'lightgrey',
    border: '3px solid' + AppTheme.borderColor,
    zIndex: 0,
    borderRadius: 18,
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
  },
  textFieldContentInput: {
    padding: 5,
    paddingLeft: 10,
    fontSize: AppTheme.subTitleSize,
    borderRadius: 18,
    color: '#656A78',
    backgroundColor: AppTheme.secondaryBg,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767
    }
  },
  textFieldContentInputDisabled: {
    padding: 5,
    paddingLeft: 10,
    fontSize: AppTheme.subTitleSize,
    borderRadius: 18,
    color: '#656A78',
    backgroundColor: 'lightgrey',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767
    }
  },
  errMsg: {
    color: AppTheme.secondaryColor,
    fontWeight: 'bold',
    minHeight: 40,
    margin: 0,
    paddingBottom: 15,
    textAlign: 'center'
  },
  errMsgContainer: {
    paddingLeft: 10,
    paddingRight: 10
  },
  stepperInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    margin: 20,
    marginTop: 0,
    alignItems: 'center',
    flex: 1,
    '@media (max-width: 767px)': {
      margin: 0,
    },
  },
  stepperInnerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // flex: 1,
    textAlign: 'center',
    maxWidth: 600,
    alignItems: 'center',
    '@media (max-width: 767px)': {
      maxWidth: 'unset',
      width: '100%'
    },
  },
  stepperTitleContent: {
    fontSize: 50,
    margin: AppTheme.pMargin,
    marginBottom: 20,
    textAlign: 'center',
    '@media (max-width: 767px)': {
      fontSize: 23,
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      fontSize: 40,
    },
  },
  stepperContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  stepperSubTitleStyle: {
    marginTop: 10
  },
  stepperSubTitleContent: {
    fontSize: 30,
    margin: AppTheme.pMargin,
    marginBottom: 10,
    whiteSpace: 'pre-line',
    textAlign: 'center',
    '@media(min-width: 768px) and (max-width: 1023px)': {
      fontSize: 25,
    },
    '@media (max-width: 767px)': {
      fontSize: 18,
    },
  },
  buttonContainer: {
    fontWeight: 'normal',
    display: 'flex',
    marginTop: 20,
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    },
  },
  innerErrorContainer: {
    maxWidth: 'unset'
  },

  errorMsgStyle: {
    color: 'red',
    height: 12,
    paddingLeft: 10
  },
  extraPadding: {
    paddingBottom: 15,
  },
  buttonContainerSecond: {
    minWidth: 200,
    fontSize: 22,
    borderRadius: 30,
    fontWeight: 'normal',
    margin: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      minWidth: 100,
      fontSize: 18,
      borderRadius: 25,
    },
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: AppTheme.tertiaryColor,
  },
  outerImageContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  buttonVariant: {
    fontWeight: 'normal',
    minWidth: 200,
    fontSize: 22,
    borderRadius: 30,
    margin: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      minWidth: 100,
      fontSize: 18,
      borderRadius: 25,
    },
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: AppTheme.tertiaryColor,
  },
  copyright: {
    fontSize: 12,
    color: AppTheme.primaryColor,
    marginTop: 10,
    textAlign: 'center'
  }
});



// WEBPACK FOOTER //
// ./src/styles/Styles.js